import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **CityEndpoint **
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a los geomarcadores.
 */
export class GeomarkerEndpoint {
  /** Endpoint que retorna la infoormación de los geomarcadores.*/
  static list = `${apiUrl}marker/`;
  /** Endpoint que retorna la infromación de un geomarcador específico.*/
  static get = `${apiUrl}marker/{}/`;
  /** Endpoint que retorna la infromación de un geomarcador inactivo espexífico.*/
  static getInactive = `${apiUrl}marker/inactive/{}/`;
  /** Endpoint que retorna la información de las caetgorias de geomarcador*/
  static categories = `${apiUrl}marker_categories/`;
  /** Endpoint que retorna la información de las valoraciones para un geomarcador específico*/
  static markerValuations = `${apiUrl}marker/{}/valuations/`;
  /** Endpoint que retorna la información de las valoraciones de una categoria hechas por un usuario*/
  static ValuationsUserMaker = `${apiUrl}users/{}/valuations/?marker_type={}`;
  /** Endpoint que retorna la información de la calificación */
  static qualificationsEdit = `${apiUrl}marker/qualification/{}/`;
  /** Endpoint que recibe la información de una calificaión para un geomarcador y asi agregargar*/
  static qualificationsAdd = `${apiUrl}marker/qualification/`;
  /** Endpoint que retorna la información de la calificación de un geomarcador hecha por un usuario*/
  static qualificationByUser = `${apiUrl}marker/{}/qualification/by_user/{}/`;
  /** Endpoint que retorna la información de las calificaciones hechas a los geomarcadores de una categoria por un usuario*/
  static qualificationUserMaker = `${apiUrl}users/{}/qualifications/?marker_type={}`;
  /** Endpoint que retorna la información de una valoración en específico*/
  static valuations = `${apiUrl}marker/valuations/{}/`;
  /** Endpoint que recibe la información de una valoracion para ser editada*/
  static valuationsEdit = `${apiUrl}marker/valuations/{}/`;
  /** Endpoint que recibe la información de una valoración para un geomarcador y luego agregarla*/
  static valuationsRest = `${apiUrl}marker/valuations/`;
  /** Endpoint que retorna la información de una valoracion de un suario para un geomarcador*/
  static valuationsByUser = `${apiUrl}marker/{}/valuations/by_user/{}/`;
  /** Endpoint que obtiene la información de servicios reservables de un geomarcador */
  static bookingService = `${apiUrl}marker/bookable_services/?id={}`;
  /** Endpoint que obtiene la información de servicios reservables de un geomarcador */
  static carouselbookingService = `${apiUrl}products/carousel/?marker={}`;
  /** Endpoint that gets information about similar geomarkers by municipality */
  static markersBy = `${apiUrl}marker/similar_by_municipality/`;
  /** Endpoint that gets ratings info for a geomarker */
  static markerInfoRatings = `${apiUrl}marker/{}/marker_ratings/`;
}
